import { render, staticRenderFns } from "./FinanceShareholderIndex.vue?vue&type=template&id=75804b87&scoped=true"
import script from "./FinanceShareholderIndex.vue?vue&type=script&lang=js"
export * from "./FinanceShareholderIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75804b87",
  null
  
)

export default component.exports